// =============================================================================
// resourceHelpLinks.ts — "link to a help item" deep links in Resources HTML
// =============================================================================
// A help link inside a Resources page is a plain anchor whose href is
// `#help=<key>`. A fragment href (a) survives sanitizeResourceHtml (which only
// neutralises javascript: URLs) and (b) never navigates the page. ResourceBody
// intercepts a click on one and opens the shared help modal for that key.
// =============================================================================

export const HELP_LINK_PREFIX = "#help=";

// Build the href for a help-item link.
export function helpHref(key: string): string {
  return `${HELP_LINK_PREFIX}${encodeURIComponent(String(key || ""))}`;
}

// The help key inside an href, or "" if it isn't a help link.
export function parseHelpKey(href: string | null | undefined): string {
  const s = String(href || "").trim();
  if (!s.startsWith(HELP_LINK_PREFIX)) return "";
  const raw = s.slice(HELP_LINK_PREFIX.length);
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}
